// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"455":"f4516a22","977":"c6b13b38"}[chunkId] + ".chunk.js";
};